// extracted by mini-css-extract-plugin
module.exports = {"contentMessage":"messageBox_contentMessage__1YRDM","messageHeading":"messageBox_messageHeading__19DYp","messageContent":"messageBox_messageContent__4NQfa"};